const BLUE = 'var(--signal)';

export default function ProgressBar({ pct }) {
  return (
    <div style={{ height: 3, backgroundColor: 'rgba(0,0,0,0.07)' }}>
      <div style={{ height: '100%', width: `${pct}%`, backgroundColor: BLUE, transition: 'width 0.3s ease' }} />
    </div>
  );
}
